import { AFFILIATION_TYPE } from '../constants/AffiliationType';

export const isAtlAffiliationEnabled = affiliationType =>
  affiliationType === AFFILIATION_TYPE.ATL_AFFILIATION;

export const isAtmAffiliationEnabled = affiliationType =>
  affiliationType === AFFILIATION_TYPE.ATL_AFFILIATION ||
  affiliationType === AFFILIATION_TYPE.ATM_AFFILIATION;
